import type { ReactNode } from 'react'
import React, { createContext, useContext, useState, useMemo } from 'react'

// Define the context value type
interface TableBodyContextValue {
  dropdownKey: number
  setDropdownKey: React.Dispatch<React.SetStateAction<number>>
}

interface TableBodyContextProviderProps {
  children: ReactNode
}

const TableBodyContext = createContext<TableBodyContextValue | undefined>(undefined)

export const TableBodyProvider = ({ children }: TableBodyContextProviderProps) => {
  const [dropdownKey, setDropdownKey] = useState<number>(0)

  const value = useMemo(() => ({ dropdownKey, setDropdownKey }), [dropdownKey])

  return <TableBodyContext.Provider value={value}>{children}</TableBodyContext.Provider>
}

export const useTableBody = () => {
  const context = useContext(TableBodyContext)

  if (context === undefined) {
    throw new Error('useTable must be called within a TableBodyContextProvider')
  }

  return context
}
